import {
  ref,
  onMounted,
  onBeforeUnmount,
  type Ref,
  type TemplateRef,
} from "vue";
import { useTemplateRef } from "#imports";

export function useSticky<T extends HTMLElement>(
  refKey: string | TemplateRef<T>,
  offset: Ref<number> = ref(0),
) {
  const elRef = typeof refKey === "string" ? useTemplateRef<T>(refKey) : refKey;
  const isSticky = ref(false);
  const elTopOffset = ref(0);
  const elBottomOffset = ref(0);

  const handleScroll = () => {
    if (!elRef.value) return;
    const rect = elRef.value.getBoundingClientRect();
    elTopOffset.value = rect.top;
    elBottomOffset.value = rect.bottom;
    isSticky.value = rect.top <= offset.value;
  };

  onMounted(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return {
    elRef,
    elTopOffset,
    elBottomOffset,
    isSticky,
    handleScroll,
  };
}
